import styled from "styled-components";

export const Container = styled.div`
  display: ${(props) => (props.show ? "flex" : "none")};
  flex: 1 1 auto;
  flex-direction: row;
  max-height: 100%;
`;
